import { Config } from 'convict';
import { ServerConfig } from '../types/ServerConfig';
import { serverConfigSchema } from '../types/serverConfigSchema';
import convict from './convict';
import defaultClientConfig from './defaultClientConfig';

const clientConfig = defaultClientConfig.getProperties();

const defaultServerConfig: Config<ServerConfig> = convict<ServerConfig>(serverConfigSchema).load({
    ...clientConfig,
    firebase: {
        ...clientConfig.firebase,
        serviceAccount: process.env.FIREBASE_ADMIN_CERT as string,
    },
    rentalsApi: {
        ...clientConfig.rentalsApi,
        accountKey: process.env.NEXT_PUBLIC_RENTALS_API_ACCOUNT_KEY as string,
    },
    auth0: {
        baseURL: process.env.NEXT_PUBLIC_APP_URL as string,
        baseURLStar: process.env.NEXT_PUBLIC_STAR_APP_URL as string,
        clientID: process.env.AUTH0_CLIENT_ID as string,
        claimsNamespace: process.env.AUTH0_CLAIMS_NAMESPACE as string,
        issuerBaseURL: process.env.AUTH0_ISSUER_BASE_URL as string,
        secret: process.env.AUTH0_SECRET as string,
        clientSecret: process.env.AUTH0_CLIENT_SECRET as string,
    },
    auth0Management: {
        domain: process.env.AUTH0_MANAGEMENT_DOMAIN as string,
        clientId: process.env.AUTH0_MANAGEMENT_CLIENT_ID as string,
        clientSecret: process.env.AUTH0_MANAGEMENT_CLIENT_SECRET as string,
    },
    mandrill: {
        apiKey: process.env.MANDRILL_API_KEY as string,
        confirmEmailTemplate: process.env.MANDRILL_CONFIRM_EMAIL_TEMPLATE as string,
    },
    log: {
        jsonEnabled: process.env.APP_LOG_JSON_ENABLED === 'true',
        traceEnabled: process.env.APP_LOG_TRACE_ENABLED === 'true',
        level: { root: process.env.APP_LOG_LEVEL || 'info' },
    },
    kariba: {
        projectId: process.env.NEXT_KARIBA_PROJECT_ID as string,
    },
    jucyCache: {
        apiKey: process.env.JUCY_CACHE_API_KEY || '',
    },
}) as unknown as Config<ServerConfig>;
export default defaultServerConfig;
